<template>
  <div>
    <div id="user-table" v-if="$auth.check(['Pull'])">
      <div v-if="loading" class="overlay">
        <div>
          <img class="spinner" src="loading.gif" alt="Loading data..." />
        </div>
      </div>

      <h1 style="text-align: left; text-transform: uppercase">
        Validação Ato Isolado
      </h1>

      <div class="zone-table-card">
        <table class="zone-table" v-if="zones.length">
          <thead>
            <tr>
              <th>Zona</th>
              <th>Estado</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="zone in zonesWithStatus" :key="zone.zone">
              <td>{{ zone.name }}</td>
              <td>
                <span
                  :class="zone.status === 'OK' ? 'status-ok' : 'status-nok'"
                >
                  {{ zone.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <label class="dropdown-container-zone box-drop-zone" for="zoneSelect">
          Selecione a Zona:
        </label>

        <select v-model="selectedZone" id="zoneSelect" @change="storeZone">
          <option v-for="zone in zones" :key="zone.zone" :value="zone.zone">
            {{ zone.name }}
          </option>
        </select>
      </div>

      <!-- DSR TABLE (WHEN ZONE SELECTED) -->
      <div
        v-if="selectedZone && dsrByZone[selectedZone]"
        class="dsr-card-wrapper"
      >
        <h3 class="zone-title">{{ getZoneName(selectedZone) }}</h3>

        <div class="dsr-table-card">
          <table class="dsr-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>UFS</th>
                <th>Estado</th>
                <th>OLA</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="dsr in dsrByZone[selectedZone]" :key="dsr.name">
                <td>{{ dsr.name }}</td>
                <td>{{ formatPoints(dsr.ufs_points) }}</td>

                <td>
                  <span
                    :class="
                      dsr.estado === 'OK'
                        ? 'status-ok'
                        : dsr.estado === 'NOK'
                        ? 'status-nok'
                        : 'status-pending'
                    "
                  >
                    {{ dsr.estado }}
                  </span>
                </td>

                <td>{{ formatPoints(dsr.ola_points) }}</td>

                <td>
                  <span
                    :class="
                      dsr.estado2 === 'OK'
                        ? 'status-ok'
                        : dsr.estado2 === 'NOK'
                        ? 'status-nok'
                        : 'status-pending'
                    "
                  >
                    {{ dsr.estado2 }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ACCESS DENIED -->
    <div v-else>
      <p>Access Denied: You are not authorized to view this page.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: null,
      team: [],
      modalOpen: false,
      currentImage: null,
      action: null,
      isModalOpen: false,
      message: "",
      rejectionId: null,
      selectedZone: null,
      starsSoCode: null,
      zoneStatusMap: {},
      zones: [],
      dsrByZone: {},
    };
  },

  computed: {
    filteredTeam() {
      // Return only entries with status_id 1 or 2
      return this.team.filter((dsr) => dsr.status_id === 0);
    },
    zonesWithStatus() {
      return this.zones.map((zone) => ({
        ...zone,
        status: this.zoneStatusMap[zone.zone] || "N/A",
      }));
    },
  },

  async mounted() {
    await this.fetchZonesStatus();
    this.fetchName();
    this.fetchTeam();
  },

  methods: {
    getZoneName(zoneCode) {
      const zone = this.zones.find((z) => z.zone === zoneCode);
      return zone ? zone.name : "";
    },

    storeZone() {
      console.log("Selected zone:", this.selectedZone);

      // Example: save to localStorage
      localStorage.setItem("selectedZone", this.selectedZone);

      // Example: save to Vuex/pinia if needed
      // this.$store.commit("setZone", this.selectedZone);
    },

    getApprovalStatus(status) {
      if (status === "1") return "OK";
      if (status === "0") return "NOK";
      return "Por aprovar";
    },

    async fetchZonesStatus() {
      this.loading = true;

      try {
        const response = await axios.get("app/CheckIsolatedStatusTeamPull");

        if (!Array.isArray(response.data)) {
          console.error("Unexpected zone status response", response.data);
          return;
        }

        const zones = [];
        const zoneStatusMap = {};
        const dsrByZone = {};

        response.data.forEach((item) => {
          const zoneCode = item.zone_code;
          const zoneName = item.zone_name;

          if (!zoneCode || !zoneName || !item.status || !item.status.original)
            return;

          const statusRoot = item.status.original;

          // Map results by DSR ID
          const resultsMap = {};
          if (Array.isArray(statusRoot.results)) {
            statusRoot.results.forEach((row) => {
              resultsMap[row.dsr_id] = row;
            });
          }

          // Add zone to list
          zones.push({
            zone: zoneCode,
            name: zoneName,
          });

          // Set overall zone status
          zoneStatusMap[zoneCode] =
            statusRoot.status && statusRoot.status.toLowerCase() === "ok"
              ? "OK"
              : "NOK";

          // Build DSRs for the zone
          const dsrs = [];

          const validDsrs = (statusRoot.dsrs && statusRoot.dsrs.valid) || [];
          const nokDsrs = (statusRoot.dsrs && statusRoot.dsrs.nok) || [];

          validDsrs.forEach((dsr) => {
            const result = resultsMap[dsr.dsr_id] || {};
            dsrs.push({
              name: dsr.name,
              ufs_points: result.ufs_points || "0",
              estado: this.getApprovalStatus(result.ufs_status),
              ola_points: result.ola_points || "0",
              estado2: this.getApprovalStatus(result.ola_status),
            });
          });

          nokDsrs.forEach((dsr) => {
            const result = resultsMap[dsr.dsr_id] || {};
            dsrs.push({
              name: dsr.name,
              ufs_points: result.ufs_points || "0",
              estado: this.getApprovalStatus(dsr.ufs_status),
              ola_points: result.ola_points || "0",
              estado2: this.getApprovalStatus(dsr.ola_status),
            });
          });

          dsrByZone[zoneCode] = dsrs;
        });

        // Commit to component state
        this.zones = zones;
        this.zoneStatusMap = zoneStatusMap;
        this.dsrByZone = dsrByZone;
      } catch (error) {
        console.error("Error fetching zone statuses:", error);
      } finally {
        this.loading = false;
      }
    },
    
    formatPoints(value) {
      if (!value || value === "-") return "-";

      var number = Math.round(Number(value));

      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    async fetchDsrId() {
      try {
        const response = await axios.get("app/getDsrId");

        return response.data.stars_so_code;
      } catch (error) {
        console.error("Error fetching DSR ID:", error);
        return null;
      }
    },

    async fetchTeam() {
      this.loading = true;
      this.error = null;

      try {
        const response = await axios.get(`app/getTeamPull`);

        if (response.status === 200 && response.data) {
          this.team = response.data;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching team data:", error);
        if (error.response) {
          console.error("Error response:", error.response.data);
        }
      } finally {
        this.loading = false; // Always reset loading
      }
    },

    openRejectionModal(id) {
      this.rejectionId = id; // Store the ID of the request being rejected
      this.isModalOpen = true; // Open the rejection modal
    },
    closeRejectionModal() {
      this.isModalOpen = false; // Close the rejection modal
      this.message = ""; // Clear the rejection message
      this.rejectionId = null; // Reset the rejection ID
    },

    async submitRejection() {
      if (!this.message.trim()) {
        alert("Por favor, insira o motivo da rejeição.");
        return;
      }

      // Send the rejection request with the message
      await this.updatePullRequest(this.rejectionId, "R", this.message);

      // Close the modal and reset fields
      this.closeRejectionModal();
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.ufs_code = response.data.ufs_code;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    openModal(imageUrl) {
      this.currentImage = imageUrl;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.currentImage = null;
    },
  },
};
</script>

<style>
.status-pending {
  color: #d98200;
  font-weight: bold;
}

.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

/* Estilos Gerais */
#user-table {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  margin: 20px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

input[type="checkbox"] {
  transform: scale(1.2);
  cursor: pointer;
}

.btn-submit {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.btn-submit:hover {
  background-color: #0056b3;
}

.table th {
  background-color: #f48c4f;
  color: white;
  vertical-align: middle;
}

textarea.form-control {
  height: 200px;
}

/* Responsividade */
.table-responsive {
  overflow-x: auto;
}

.comprovativo-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  align-items: center;
}

/* Botões */
.btn-accept,
.btn-reject {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  margin: 0 5px;
}

.btn-accept {
  color: #00c939;
}

.btn-reject {
  color: red;
}

.btn-accept:hover {
  color: #008f2c;
}

.btn-reject:hover {
  color: #cc0000;
}

/* Ajustes para telas pequenas */
@media (max-width: 768px) {
  .table th,
  .table td {
    font-size: 12px;
    padding: 5px;
    vertical-align: middle !important;
  }

  .comprovativo-img {
    width: 40px;
    height: 40px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 14px;
  }
}

.format {
  background-color: none;
  border: none;
  color: #ff5a00;
}

@media (max-width: 480px) {
  h1 {
    font-size: 18px;
    text-align: center;
  }

  .card {
    padding: 10px;
  }

  .table th,
  .table td {
    font-size: 10px;
    padding: 3px;
    text-align-last: center;
    vertical-align: middle;
  }

  .comprovativo-img {
    width: 30px;
    height: 30px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 12px;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.modal-content img {
  width: 100%;
  height: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .form-group {
  margin-bottom: 15px;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

.close:hover {
  color: black;
}

.main .container-fluid {
  padding: 50px 5px !important;
}

.btn-view-image {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

.btn-view-image:hover {
  background-color: #0056b3;
}

#zoneSelect {
  padding: 5px 10px;
  border: 1px solid #f48c4f;
  border-radius: 12px;
  font-size: small;
  text-align: center;
}

.zone-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.zone-table th,
.zone-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.status-ok {
  color: green;
  font-weight: bold;
}

.status-nok {
  color: red;
  font-weight: bold;
}

.zone-table-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 0px 20px 20px 20px;
  margin: 20px 0px 20px 0px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.zone-title {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0 10px 0;
  color: #333;
}

.dsr-card-wrapper {
  margin-top: 20px;
}

.dsr-table-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin: 10px 0 30px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.dsr-table {
  width: 100%;
  border-collapse: collapse;
}

.dsr-table th {
  background-color: #f48c4f;
  color: white;
  padding: 10px;
}

.dsr-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
</style>
